
export function getLocale() {
  return document.documentElement.lang ?? 'en'
}
